import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Loading component that shows during theme transitions
 * Helps provide visual feedback when theme switching takes time
 */
const ThemeTransitionLoader = ({ 
  isVisible = false, 
  message = 'Switching theme...',
  className = '' 
}) => {
  const [showLoader, setShowLoader] = useState(false);
  
  useEffect(() => {
    if (isVisible) {
      setShowLoader(true);
      // Auto-hide after 2 seconds
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 2000);
      
      return () => clearTimeout(timer);
    } else {
      setShowLoader(false);
    }
  }, [isVisible]);
  
  if (!showLoader) return null;
  
  return (
    <div className={`theme-transition-loader fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ${className}`}>
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-lg flex items-center space-x-3">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        <span className="text-gray-700 dark:text-gray-300 font-medium">
          {message}
        </span>
      </div>
    </div>
  );
};

ThemeTransitionLoader.propTypes = {
  isVisible: PropTypes.bool,
  message: PropTypes.string,
  className: PropTypes.string
};

export default ThemeTransitionLoader;


